import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

export default function MagicLinkTicket() {
  const { token } = useParams();
  const [form, setForm] = useState({ title: '', description: '', submitted_by: '' });
  const [status, setStatus] = useState('idle');
  const [ticketNumber, setTicketNumber] = useState('');
  const [invalid, setInvalid] = useState(false);

  const handleSubmit = async () => {
    if (!form.title.trim()) return;
    setStatus('loading');
    try {
      const res = await fetch('/api/magiclinks/submit/' + token, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) {
        if (res.status === 404) { setInvalid(true); return; }
        setStatus('error');
        return;
      }
      setTicketNumber(data.ticket_number);
      setStatus('success');
    } catch (e) {
      setStatus('error');
    }
  };

  if (invalid) return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-8 max-w-md w-full text-center">
        <div className="text-4xl mb-4">🔗</div>
        <h1 className="text-lg font-semibold text-gray-900 mb-2">Link nicht gueltig</h1>
        <p className="text-sm text-gray-500">Dieser Link ist nicht mehr aktiv. Bitte wende dich direkt an Emge-Computer.</p>
      </div>
    </div>
  );

  if (status === 'success') return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-8 max-w-md w-full text-center">
        <div className="text-4xl mb-4">✅</div>
        <h1 className="text-lg font-semibold text-gray-900 mb-2">Ticket eingereicht</h1>
        <p className="text-sm text-gray-500 mb-3">Deine Anfrage wurde erfolgreich uebermittelt.</p>
        <div className="bg-gray-50 rounded-xl px-4 py-3 inline-block">
          <p className="text-xs text-gray-400 mb-0.5">Ticketnummer</p>
          <p className="text-lg font-bold text-gray-900">{ticketNumber}</p>
        </div>
        <p className="text-xs text-gray-400 mt-4">Ihr Ticket wurde an unser Support-Team weitergeleitet. Wir werden uns zeitnah bei Ihnen melden.</p>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 max-w-md w-full">
        <div className="mb-6 text-center">
          <img src="/logo.png" alt="Emge Computer" className="h-20 w-20 object-contain mx-auto mb-3" />
          <h1 className="text-xl font-bold text-gray-900">Support-Anfrage</h1>
          <p className="text-sm text-gray-500 mt-1">Emge-Computer · IT-Support</p>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Ihr Name</label>
            <input type="text" value={form.submitted_by}
              onChange={e => setForm({...form, submitted_by: e.target.value})}
              placeholder="Max Mustermann"
              className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Betreff *</label>
            <input type="text" value={form.title}
              onChange={e => setForm({...form, title: e.target.value})}
              placeholder="Kurze Beschreibung des Problems"
              className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Beschreibung</label>
            <textarea value={form.description}
              onChange={e => setForm({...form, description: e.target.value})}
              rows={5} placeholder="Beschreibe das Problem so genau wie moeglich..."
              className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none" />
          </div>

          {status === 'error' && (
            <p className="text-xs text-red-500">Fehler beim Einreichen. Bitte versuche es erneut.</p>
          )}

          <button onClick={handleSubmit} disabled={status === 'loading' || !form.title.trim()}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-4 py-3 rounded-xl transition-colors disabled:opacity-50">
            {status === 'loading' ? 'Wird uebermittelt...' : 'Support-Anfrage senden'}
          </button>
        </div>
      </div>
    </div>
  );
}
